export default "__VITE_ASSET__CEG6cE0Q__"